import { makeStyles } from '@material-ui/core/styles'

export const fullSizeDialogStyle = makeStyles(theme => ({
  actions: {
    padding: '0px !important'
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(-2.5),
    right: theme.spacing(-2.5),
    backgroundColor: theme.palette.geoColors.toolBar.light,
    color: theme.palette.geoColors.toolBar.main,
    '&:hover': {
      backgroundColor: `${theme.palette.geoColors.toolBar.light}cc`
    }
  },
  content: {
    padding: `${theme.spacing(1)}px !important`,
    paddingBottom: `${theme.spacing(0.5)}px !important`
  },
  root: {
    overflowY: 'unset'
  }
}))
